import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  BooleanField,
  SearchInput,
  BooleanInput,
  NumberInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  FunctionField,
} from 'react-admin';
import { Chip } from '@mui/material';

const chatFilters = [
  <SearchInput
    key="search"
    source="q"
    placeholder="Search by title, username, or owner"
    alwaysOn
  />,
  <NumberInput key="owner_id" source="owner_id" label="Owner ID" />,
  <BooleanInput key="has_api_key" source="has_api_key" label="Has xRocket API Key" />,
];

const ChatListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const UsernameField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const username = record[source];
      if (!username) return <span style={{ color: '#999' }}>-</span>;
      return <span>@{username}</span>;
    }}
  />
);

const ApiKeyStatusField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const hasKey = record[source];
      return (
        <Chip
          label={hasKey ? 'CONFIGURED' : 'NOT SET'}
          color={hasKey ? 'success' : 'default'}
          size="small"
        />
      );
    }}
  />
);

const EventCountField = ({ record }: { record: any }) => {
  const total = record.total_events || 0;
  const active = record.active_events || 0;

  if (total === 0) return <span>-</span>;

  return (
    <span>
      {active > 0 && <strong style={{ color: '#4caf50' }}>{active} active</strong>}
      {active > 0 && total > active && ' / '}
      {total > active && <span>{total - active} ended</span>}
    </span>
  );
};

export const ChatList = () => (
  <List
    filters={chatFilters}
    actions={<ChatListActions />}
    perPage={50}
    sort={{ field: 'chat_id', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="chat_id" label="Chat ID" />
      <TextField source="title" label="Chat Title" />
      <UsernameField source="username" />
      <TextField source="owner_username" label="Owner" />
      <FunctionField
        label="Events"
        render={(record: any) => <EventCountField record={record} />}
      />
      <ApiKeyStatusField source="has_api_key" />
      <DateField source="created_at" showTime label="Created" />
    </Datagrid>
  </List>
);
